import PageableBase from 'app/collections/pageable_base';

export default PageableBase.extend({
  key: 'reports',

  initialize(models, { apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;

    this.listenTo(this.apiModeSelection, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return { ...this.apiModeSelection.getParams() };
  },
});



// WEBPACK FOOTER //
// ./app/collections/reports_base.js